

app.controller('CIF3-CTRL', function ($scope, $rootScope, $routeParams, uibDateParser, $uibModal, $http, $window, $location, $timeout, Upload, $q, $filter) {
    $scope.CIFInvestor = {}

    $scope.ListSecurityQuestion =
    [
        { key: "1", value: "keyquestion1" },
        { key: "2", value: "keyquestion2" },
        { key: "3", value: "keyquestion3" },
        { key: "4", value: "keyquestion4" },
        { key: "5", value: "keyquestion5" },
        { key: "6", value: "keyquestion6" },
        { key: "7", value: "keyquestion7" },
        { key: "8", value: "keyquestion8" },
        { key: "9", value: "keyquestion9" },
        { key: "10", value: "keyquestion10" },
    ];




    $scope.answer1 = '';
    $scope.answer2 = '';
    $scope.answer3 = '';
    $scope.answer4 = '';
    $scope.answer5 = '';


    $scope.ListSecurityQuestion1 = [];
    $scope.ListSecurityQuestion2 = [];
    $scope.ListSecurityQuestion3 = [];
    $scope.ListSecurityQuestion4 = [];
    $scope.ListSecurityQuestion5 = [];

    $scope.showKeyQuestion1 = false;
    $scope.showQuestion2 = false;

    $scope.SecurityQuestion1Change = function () {
        $scope.CIFInvestor.KeySecurityQuestion1 = '';


        if ($scope.CIFInvestor.SecurityQuestion2)
        {

            if ($scope.CIFInvestor.SecurityQuestion1)
            {
                var list1 = $filter('filter')($scope.ListSecurityQuestion, function (item) {
                    return item.key != $scope.CIFInvestor.SecurityQuestion1;
                });

                if ($scope.CIFInvestor.SecurityQuestion3)
                {
                    var list2 = $filter('filter')(list1, function (item) {
                        return item.key != $scope.CIFInvestor.SecurityQuestion3;
                    });

                    if ($scope.CIFInvestor.SecurityQuestion4)
                    {
                        var list3 = $filter('filter')(list2, function (item) {
                            return item.key != $scope.CIFInvestor.SecurityQuestion4;
                        });

                        if ($scope.CIFInvestor.SecurityQuestion5)
                        {
                            var list4 = $filter('filter')(list3, function (item) {
                                return item.key != $scope.CIFInvestor.SecurityQuestion5;
                            });

                            $scope.ListSecurityQuestion2 = list4;
                        }
                    }
                    else
                        $scope.ListSecurityQuestion2 = list3;
                }
            }
        }
        else
        {
            if ($scope.CIFInvestor.SecurityQuestion1) {
                var list = $filter('filter')($scope.ListSecurityQuestion, function (item) {
                    return item.key != $scope.CIFInvestor.SecurityQuestion1;
                });

                $scope.ListSecurityQuestion2 = list;
                //$scope.ListSecurityQuestion3 = [];
                //$scope.ListSecurityQuestion4 = [];
                //$scope.ListSecurityQuestion5 = [];
            }
        }

        console.log('list2', $scope.ListSecurityQuestion2);
    };

    $scope.SecurityQuestion2Change = function () {
        $scope.CIFInvestor.KeySecurityQuestion2 = '';

        if ($scope.CIFInvestor.SecurityQuestion3)
        {

            if ($scope.CIFInvestor.SecurityQuestion1) {
                var list1 = $filter('filter')($scope.ListSecurityQuestion, function (item) {
                    return item.key != $scope.CIFInvestor.SecurityQuestion1;
                });

                if ($scope.CIFInvestor.SecurityQuestion2) {
                    var list2 = $filter('filter')(list1, function (item) {
                        return item.key != $scope.CIFInvestor.SecurityQuestion2;
                    });

                    if ($scope.CIFInvestor.SecurityQuestion4) {
                        var list3 = $filter('filter')(list2, function (item) {
                            return item.key != $scope.CIFInvestor.SecurityQuestion4;
                        });

                        if ($scope.CIFInvestor.SecurityQuestion5) {
                            var list4 = $filter('filter')(list3, function (item) {
                                return item.key != $scope.CIFInvestor.SecurityQuestion5;
                            });

                            $scope.ListSecurityQuestion3 = list4;
                        }
                    }
                    else
                        $scope.ListSecurityQuestion3 = list3;
                }
            }
        }
        else
        {
            if ($scope.CIFInvestor.SecurityQuestion2) {
                var list1 = $filter('filter')($scope.ListSecurityQuestion, function (item) {
                    return item.key != $scope.CIFInvestor.SecurityQuestion2;
                });

                var list2 = $filter('filter')($scope.ListSecurityQuestion, function (item) {
                    return item.key != $scope.CIFInvestor.SecurityQuestion1;
                });

                var list3 = $filter('filter')($scope.ListSecurityQuestion2, function (item) {
                    return item.key != $scope.CIFInvestor.SecurityQuestion2;
                });

                $scope.ListSecurityQuestion1 = list1;
                $scope.ListSecurityQuestion2 = list2;
                $scope.ListSecurityQuestion3 = list3;
                //$scope.ListSecurityQuestion4 = [];
                //$scope.ListSecurityQuestion5 = [];
            }
            //else
            //{
            //    $scope.ListSecurityQuestion2
            //}
        }
        
    };

    $scope.SecurityQuestion3Change = function () {
        $scope.CIFInvestor.KeySecurityQuestion3 = '';

        if ($scope.CIFInvestor.SecurityQuestion4) {

            if ($scope.CIFInvestor.SecurityQuestion1) {
                var list1 = $filter('filter')($scope.ListSecurityQuestion, function (item) {
                    return item.key != $scope.CIFInvestor.SecurityQuestion1;
                });

                if ($scope.CIFInvestor.SecurityQuestion2) {
                    var list2 = $filter('filter')(list1, function (item) {
                        return item.key != $scope.CIFInvestor.SecurityQuestion2;
                    });

                    if ($scope.CIFInvestor.SecurityQuestion3) {
                        var list3 = $filter('filter')(list2, function (item) {
                            return item.key != $scope.CIFInvestor.SecurityQuestion3;
                        });

                        if ($scope.CIFInvestor.SecurityQuestion5) {
                            var list4 = $filter('filter')(list3, function (item) {
                                return item.key != $scope.CIFInvestor.SecurityQuestion5;
                            });

                            $scope.ListSecurityQuestion4 = list4;
                        }
                    }
                    else
                        $scope.ListSecurityQuestion4 = list3;
                }
            }
        }
        else
        {
            if ($scope.CIFInvestor.SecurityQuestion3) {
                var list1 = $filter('filter')($scope.ListSecurityQuestion1, function (item) {
                    return item.key != $scope.CIFInvestor.SecurityQuestion3;
                });

                var list2 = $filter('filter')($scope.ListSecurityQuestion2, function (item) {
                    return item.key != $scope.CIFInvestor.SecurityQuestion3;
                });

                var list3 = $filter('filter')($scope.ListSecurityQuestion3, function (item) {
                    return item.key != $scope.CIFInvestor.SecurityQuestion3;
                });

                $scope.ListSecurityQuestion1 = list1;
                $scope.ListSecurityQuestion2 = list2;
                $scope.ListSecurityQuestion4 = list3;
                //$scope.ListSecurityQuestion5 = [];
            }
        }
        
    };

    $scope.SecurityQuestion4Change = function () {
        $scope.CIFInvestor.KeySecurityQuestion4 = '';

        if ($scope.CIFInvestor.SecurityQuestion5) {

            if ($scope.CIFInvestor.SecurityQuestion1) {
                var list1 = $filter('filter')($scope.ListSecurityQuestion, function (item) {
                    return item.key != $scope.CIFInvestor.SecurityQuestion1;
                });

                if ($scope.CIFInvestor.SecurityQuestion2) {
                    var list2 = $filter('filter')(list1, function (item) {
                        return item.key != $scope.CIFInvestor.SecurityQuestion2;
                    });

                    if ($scope.CIFInvestor.SecurityQuestion3) {
                        var list3 = $filter('filter')(list2, function (item) {
                            return item.key != $scope.CIFInvestor.SecurityQuestion3;
                        });

                        if ($scope.CIFInvestor.SecurityQuestion4) {
                            var list4 = $filter('filter')(list3, function (item) {
                                return item.key != $scope.CIFInvestor.SecurityQuestion4;
                            });

                            $scope.ListSecurityQuestion5 = list4;
                        }
                    }
                    else
                        $scope.ListSecurityQuestion5 = list3;
                }
            }
        }
        else
        {
            if ($scope.CIFInvestor.SecurityQuestion4) {
                var list1 = $filter('filter')($scope.ListSecurityQuestion1, function (item) {
                    return item.key != $scope.CIFInvestor.SecurityQuestion4;
                });

                var list2 = $filter('filter')($scope.ListSecurityQuestion2, function (item) {
                    return item.key != $scope.CIFInvestor.SecurityQuestion4;
                });

                var list3 = $filter('filter')($scope.ListSecurityQuestion3, function (item) {
                    return item.key != $scope.CIFInvestor.SecurityQuestion4;
                });

                var list4 = $filter('filter')($scope.ListSecurityQuestion4, function (item) {
                    return item.key != $scope.CIFInvestor.SecurityQuestion4;
                });

                $scope.ListSecurityQuestion1 = list1;
                $scope.ListSecurityQuestion2 = list2;
                $scope.ListSecurityQuestion3 = list3;
                $scope.ListSecurityQuestion5 = list4;
            }
        }

        
    };

    $scope.SecurityQuestion5Change = function () {
        $scope.CIFInvestor.KeySecurityQuestion5 = '';

        if ($scope.CIFInvestor.SecurityQuestion5) {
            var list1 = $filter('filter')($scope.ListSecurityQuestion1, function (item) {
                return item.key != $scope.CIFInvestor.SecurityQuestion5;
            });

            var list2 = $filter('filter')($scope.ListSecurityQuestion2, function (item) {
                return item.key != $scope.CIFInvestor.SecurityQuestion5;
            });

            var list3 = $filter('filter')($scope.ListSecurityQuestion3, function (item) {
                return item.key != $scope.CIFInvestor.SecurityQuestion5;
            });

            var list4 = $filter('filter')($scope.ListSecurityQuestion4, function (item) {
                return item.key != $scope.CIFInvestor.SecurityQuestion5;
            });

            $scope.ListSecurityQuestion1 = list1;
            $scope.ListSecurityQuestion2 = list2;
            $scope.ListSecurityQuestion3 = list3;
            $scope.ListSecurityQuestion4 = list4;
        }
    };

    $scope.chkquestionfatca = true;
    $scope.chkquestion1 = false;
    $scope.chkquestion2 = false;
    $scope.chkquestion3 = false;
    $scope.chkquestion4 = false;

    $scope.ddlQuestion1 = '';
    $scope.ddlQuestion2 = '';
    $scope.ddlQuestion3 = '';
    $scope.ddlQuestion4 = '';
    $scope.ddlQuestion5 = '';
    $scope.ddlQuestion6 = '';

    $scope.Question1Change = function () {
        if ($scope.ddlQuestion1)
        {
            if ($scope.ddlQuestion1 == '1')
            {
                $scope.CIFInvestor.Question1 = 'Ya';
                $scope.chkquestion1 = true;
            }
            else
            {
                $scope.CIFInvestor.Question1 = 'Tidak';
                $scope.CIFInvestor.Question1_Text = '';
                $scope.chkquestion1 = false;
            }
        }
    }
    $scope.Question2Change = function () {
        if ($scope.ddlQuestion2) {
            if ($scope.ddlQuestion2 == '1') {
                $scope.CIFInvestor.Question2 = 'Ya';
                $scope.chkquestion2 = true;
            }
            else {
                $scope.CIFInvestor.Question2 = 'Tidak';
                $scope.CIFInvestor.Question2_Text = '';
                $scope.chkquestion2 = false;
            }
        }
    }
    $scope.Question3Change = function () {
        if ($scope.ddlQuestion3) {
            if ($scope.ddlQuestion3 == '1') {
                $scope.CIFInvestor.Question3 = 'Ya';
                $scope.chkquestion3 = true;
            }
            else {
                $scope.CIFInvestor.Question3 = 'Tidak';
                $scope.CIFInvestor.Question3_Text = '';
                $scope.chkquestion3 = false;
            }
        }
    }
    $scope.Question4Change = function () {
        if ($scope.ddlQuestion4) {
            if ($scope.ddlQuestion4 == '1') {
                $scope.CIFInvestor.Question4 = 'Ya';
                $scope.chkquestion4 = true;
            }
            else {
                $scope.CIFInvestor.Question4 = 'Tidak';
                $scope.CIFInvestor.Question4_Text = '';
                $scope.chkquestion4 = false;
            }
        }
    }
    $scope.Question5Change = function () {
        if ($scope.ddlQuestion5) {
            if ($scope.ddlQuestion5 == '1') {
                $scope.CIFInvestor.Question5 = 'Ya';
                $scope.chkquestion5 = true;
            }
            else {
                $scope.CIFInvestor.Question5 = 'Tidak';
                $scope.CIFInvestor.Question5_Text = '';
                $scope.chkquestion4 = false;
            }
        }
    }
    $scope.Question6Change = function () {
        if ($scope.ddlQuestion6) {
            if ($scope.ddlQuestion6 == '1') {
                $scope.CIFInvestor.Question6 = 'Ya';
                $scope.chkquestion6 = true;
            }
            else {
                $scope.CIFInvestor.Question6 = 'Tidak';
                $scope.CIFInvestor.Question6_Text = '';
                $scope.chkquestion6 = false;
            }
        }
    }

    $scope.keyQuestionRequired = true;
    $scope.countKeyQuestion = 0;

    $scope.print = function () {
        $scope.prepareData();
    }



    var allPromise = $q.all([
       $http({
           method: 'GET',
           url: '/service/client.svc/GetCIFLookup',
           cache: true,
       }).then(function (data) {
           $scope.ListLookup = data.data.d;
           if ($scope.ListLookup) {
               $scope.ListInvestmentObjectives = $filter('filter')($scope.ListLookup, { CIFLookupID: 'InvestmentObjectives' }, true);
               $scope.ListRisk = $filter('filter')($scope.ListLookup, { CIFLookupID: 'Risk' }, true);
            
           }
       }, function (error) { }),

       $http({
           method: 'POST',
           url: '/service/client.svc/retrieveSession',
       }).then(function (data) {
           if (!data.data.d) {
               $http({
                   method: 'GET',
                   url: '/service/client.svc/SignOut',
               }).then(function (data) {
                   if (data.data.d == true) {
                       $window.location.href = "#/login";
                       $window.location.reload();
                   }
               }, function (error) { })
           }
           else
               $scope.currentUser = data.data.d;
       }, function (error) { }),

        $scope.ListSecurityQuestion1 = $scope.ListSecurityQuestion
    ]);

    allPromise.then(function () {
        $http({
            method: 'GET',
            url: '/service/client.svc/getCIF',
        }).then(function (data) {
            if (data.data.d != null) {
                var obj = data.data.d;
                $scope.CIFInvestor = data.data.d;
                console.log("DATA", $scope.CIFInvestor);
                $scope.CIFInvestor.Stage = 3;
                
                if ($scope.CIFInvestor.FATCA1 == 'Ya' || $scope.CIFInvestor.FATCA2 == 'Ya' || $scope.CIFInvestor.FATCA3 == 'Ya')
                {
                    $scope.chkquestionfatca = false;
                }

                if ($scope.CIFInvestor.InvestmentObjectives == 0)
                    $scope.CIFInvestor.InvestmentObjectives = '';

                if($scope.CIFInvestor.Question1)
                {
                    if ($scope.CIFInvestor.Question1 == 'Ya')
                        $scope.ddlQuestion1 = '1';
                    else
                        $scope.ddlQuestion1 = '2';
                }

                if ($scope.CIFInvestor.Question2) {
                    if ($scope.CIFInvestor.Question2 == 'Ya')
                        $scope.ddlQuestion2 = '1';
                    else
                        $scope.ddlQuestion2 = '2';
                }

                if ($scope.CIFInvestor.Question3) {
                    if ($scope.CIFInvestor.Question3 == 'Ya')
                        $scope.ddlQuestion3 = '1';
                    else
                        $scope.ddlQuestion3 = '2';
                }

                if ($scope.CIFInvestor.Question4) {
                    if ($scope.CIFInvestor.Question4 == 'Ya')
                        $scope.ddlQuestion4 = '1';
                    else
                        $scope.ddlQuestion4 = '2';
                }

                if ($scope.CIFInvestor.Question5) {
                    if ($scope.CIFInvestor.Question5 == 'Ya')
                        $scope.ddlQuestion5 = '1';
                    else
                        $scope.ddlQuestion5 = '2';
                }
                if ($scope.CIFInvestor.Question6) {
                    if ($scope.CIFInvestor.Question6 == 'Ya')
                        $scope.ddlQuestion6 = '1';
                    else
                        $scope.ddlQuestion6 = '2';
                }

                //KEY QUESTION
                if ($scope.CIFInvestor.KeyQuestion1) {
                    if ($scope.CIFInvestor.KeyQuestion1 != "")
                        $scope.countKeyQuestion = $scope.countKeyQuestion + 1;

                    if ($scope.countKeyQuestion >= 5)
                        $scope.keyQuestionRequired = false;
                }

                if ($scope.CIFInvestor.KeyQuestion2) {
                    if ($scope.CIFInvestor.KeyQuestion2 != "")
                        $scope.countKeyQuestion = $scope.countKeyQuestion + 1;

                    if ($scope.countKeyQuestion >= 5)
                        $scope.keyQuestionRequired = false;
                }

                if ($scope.CIFInvestor.KeyQuestion3) {
                    if ($scope.CIFInvestor.KeyQuestion3 != "")
                        $scope.countKeyQuestion = $scope.countKeyQuestion + 1;

                    if ($scope.countKeyQuestion >= 5)
                        $scope.keyQuestionRequired = false;
                }

                if ($scope.CIFInvestor.KeyQuestion4) {
                    if ($scope.CIFInvestor.KeyQuestion4 != "")
                        $scope.countKeyQuestion = $scope.countKeyQuestion + 1;

                    if ($scope.countKeyQuestion >= 5)
                        $scope.keyQuestionRequired = false;
                }

                if ($scope.CIFInvestor.KeyQuestion5) {
                    if ($scope.CIFInvestor.KeyQuestion5 != "")
                        $scope.countKeyQuestion = $scope.countKeyQuestion + 1;

                    if ($scope.countKeyQuestion >= 5)
                        $scope.keyQuestionRequired = false;
                }

                if ($scope.CIFInvestor.KeyQuestion6) {
                    if ($scope.CIFInvestor.KeyQuestion6 != "")
                        $scope.countKeyQuestion = $scope.countKeyQuestion + 1;

                    if ($scope.countKeyQuestion >= 5)
                        $scope.keyQuestionRequired = false;
                }

                if ($scope.CIFInvestor.KeyQuestion7) {
                    if ($scope.CIFInvestor.KeyQuestion7 != "")
                        $scope.countKeyQuestion = $scope.countKeyQuestion + 1;

                    if ($scope.countKeyQuestion >= 5)
                        $scope.keyQuestionRequired = false;
                }

                if ($scope.CIFInvestor.KeyQuestion8) {
                    if ($scope.CIFInvestor.KeyQuestion8 != "")
                        $scope.countKeyQuestion = $scope.countKeyQuestion + 1;

                    if ($scope.countKeyQuestion >= 5)
                        $scope.keyQuestionRequired = false;
                }

                if ($scope.CIFInvestor.KeyQuestion9) {
                    if ($scope.CIFInvestor.KeyQuestion9 != "")
                        $scope.countKeyQuestion = $scope.countKeyQuestion + 1;

                    if ($scope.countKeyQuestion >= 5)
                        $scope.keyQuestionRequired = false;
                }

                if ($scope.CIFInvestor.KeyQuestion10) {
                    if ($scope.CIFInvestor.KeyQuestion10 != "")
                        $scope.countKeyQuestion = $scope.countKeyQuestion + 1;

                    if ($scope.countKeyQuestion >= 5)
                        $scope.keyQuestionRequired = false;
                }

                if($scope.CIFInvestor.SecurityQuestion1)
                {
                    var list = $filter('filter')($scope.ListSecurityQuestion, function (item) {
                        return item.key != $scope.CIFInvestor.SecurityQuestion2 && item.key != $scope.CIFInvestor.SecurityQuestion3 && item.key != $scope.CIFInvestor.SecurityQuestion4 && item.key != $scope.CIFInvestor.SecurityQuestion5;
                    });

                    $scope.ListSecurityQuestion1 = list;
                }

                if ($scope.CIFInvestor.SecurityQuestion2) {
                    var list = $filter('filter')($scope.ListSecurityQuestion, function (item) {
                        return item.key != $scope.CIFInvestor.SecurityQuestion1 && item.key != $scope.CIFInvestor.SecurityQuestion3 && item.key != $scope.CIFInvestor.SecurityQuestion4 && item.key != $scope.CIFInvestor.SecurityQuestion5;
                    });

                    $scope.ListSecurityQuestion2 = list;
                }

                if ($scope.CIFInvestor.SecurityQuestion3) {
                    var list = $filter('filter')($scope.ListSecurityQuestion, function (item) {
                        return item.key != $scope.CIFInvestor.SecurityQuestion1 && item.key != $scope.CIFInvestor.SecurityQuestion2 && item.key != $scope.CIFInvestor.SecurityQuestion4 && item.key != $scope.CIFInvestor.SecurityQuestion5;
                    });

                    $scope.ListSecurityQuestion3 = list;
                }

                if ($scope.CIFInvestor.SecurityQuestion4) {
                    var list = $filter('filter')($scope.ListSecurityQuestion, function (item) {
                        return item.key != $scope.CIFInvestor.SecurityQuestion1 && item.key != $scope.CIFInvestor.SecurityQuestion2 && item.key != $scope.CIFInvestor.SecurityQuestion3 && item.key != $scope.CIFInvestor.SecurityQuestion5;
                    });

                    $scope.ListSecurityQuestion4 = list;
                }

                if ($scope.CIFInvestor.SecurityQuestion5) {
                    var list = $filter('filter')($scope.ListSecurityQuestion, function (item) {
                        return item.key != $scope.CIFInvestor.SecurityQuestion1 && item.key != $scope.CIFInvestor.SecurityQuestion2 && item.key != $scope.CIFInvestor.SecurityQuestion3 && item.key != $scope.CIFInvestor.SecurityQuestion4;
                    });

                    $scope.ListSecurityQuestion5 = list;
                }

               
            } // END IF data.data.d
        }, function (error) { });
    });

    $scope.printQ = function () {
        console.log('Q',$scope.availableQ);
    }

    $scope.prepareData = function () {

        if ($scope.chkquestionfatca)
        {
            if ($scope.chkquestionfatca = true)
            {

                $scope.CIFInvestor.FATCA1 = 'Tidak';
                $scope.CIFInvestor.FATCA2 = 'Tidak';
                $scope.CIFInvestor.FATCA3 = 'Tidak';
            }
        }

    }

    $scope.submit = function () {
        $scope.prepareData();
        var finished = 0;

        $scope.working = true;

        $rootScope.AlertYesNo('question', 'Konfirmasi', "Apakah data yang diisi sudah sesuai?")
        .then((result) => {
            if (result.value) {
                console.log('keyquestion2', $scope.CIFInvestor.KeyQuestion1);
                $rootScope.AlertShowLoading('warning', 'Loading...', '', 0);
                $http({
                    method: 'POST',
                    url: '/service/client.svc/SaveCIF',
                    data:
                        {
                            cifdata: $scope.CIFInvestor
                        },
                }).then(function (data) {
                    
                    if (data.data.d.result) {
                        swal.close();
                        $window.location.href = "#/cif/data-pernyataan";
                    }
                    else {
                        swal('Failed', data.data.d.message, 'error');
                    }
                }, function (error) {
                    swal('Error', 'error - Please check your connection', 'error');
                });
            }
        });

    }

    $scope.keyQuestion1Change = function () {
        if ($scope.CIFInvestor.KeyQuestion1) {
            if ($scope.CIFInvestor.KeyQuestion1 != "")
                $scope.countKeyQuestion = $scope.countKeyQuestion + 1;

            if($scope.countKeyQuestion >= 5)
                $scope.keyQuestionRequired = false;
        }

        console.log('asd', $scope.CIFInvestor.KeyQuestion1);
        console.log('countKeyQuestion', $scope.countKeyQuestion);
    };

    $scope.keyQuestion2Change = function () {
        if ($scope.CIFInvestor.KeyQuestion2) {
            if ($scope.CIFInvestor.KeyQuestion2 != "")
                $scope.countKeyQuestion = $scope.countKeyQuestion + 1;

            if ($scope.countKeyQuestion >= 5)
                $scope.keyQuestionRequired = false;
        }

        console.log('countKeyQuestion2', $scope.countKeyQuestion);
    };

    $scope.keyQuestion3Change = function () {
        if ($scope.CIFInvestor.KeyQuestion3) {
            if ($scope.CIFInvestor.KeyQuestion3 != "")
                $scope.countKeyQuestion = $scope.countKeyQuestion + 1;

            if ($scope.countKeyQuestion >= 5)
                $scope.keyQuestionRequired = false;
        }

        console.log('countKeyQuestion3', $scope.countKeyQuestion);
    };

    $scope.keyQuestion4Change = function () {
        if ($scope.CIFInvestor.KeyQuestion4) {
            if ($scope.CIFInvestor.KeyQuestion4 != "")
                $scope.countKeyQuestion = $scope.countKeyQuestion + 1;

            if ($scope.countKeyQuestion >= 5)
                $scope.keyQuestionRequired = false;
        }

        console.log('countKeyQuestion4', $scope.countKeyQuestion);
    };

    $scope.keyQuestion5Change = function () {
        if ($scope.CIFInvestor.KeyQuestion5) {
            if ($scope.CIFInvestor.KeyQuestion5 != "")
                $scope.countKeyQuestion = $scope.countKeyQuestion + 1;

            if ($scope.countKeyQuestion >= 5)
                $scope.keyQuestionRequired = false;
        }

        console.log('countKeyQuestion5', $scope.countKeyQuestion);
    };

    $scope.keyQuestion6Change = function () {
        if ($scope.CIFInvestor.KeyQuestion6) {
            if ($scope.CIFInvestor.KeyQuestion6 != "")
                $scope.countKeyQuestion = $scope.countKeyQuestion + 1;

            if ($scope.countKeyQuestion >= 5)
                $scope.keyQuestionRequired = false;
        }

        console.log('countKeyQuestion6', $scope.countKeyQuestion);
    };

    $scope.keyQuestion7Change = function () {
        if ($scope.CIFInvestor.KeyQuestion7) {
            if ($scope.CIFInvestor.KeyQuestion7 != "")
                $scope.countKeyQuestion = $scope.countKeyQuestion + 1;

            if ($scope.countKeyQuestion >= 5)
                $scope.keyQuestionRequired = false;
        }

        console.log('countKeyQuestion7', $scope.countKeyQuestion);
    };

    $scope.keyQuestion8Change = function () {
        if ($scope.CIFInvestor.KeyQuestion8) {
            if ($scope.CIFInvestor.KeyQuestion8 != "")
                $scope.countKeyQuestion = $scope.countKeyQuestion + 1;

            if ($scope.countKeyQuestion >= 5)
                $scope.keyQuestionRequired = false;
        }

        console.log('countKeyQuestion8', $scope.countKeyQuestion);
    };

    $scope.keyQuestion9Change = function () {
        if ($scope.CIFInvestor.KeyQuestion9) {
            if ($scope.CIFInvestor.KeyQuestion9 != "")
                $scope.countKeyQuestion = $scope.countKeyQuestion + 1;

            if ($scope.countKeyQuestion >= 5)
                $scope.keyQuestionRequired = false;
        }

        console.log('countKeyQuestion9', $scope.countKeyQuestion);
    };

    $scope.keyQuestion10Change = function () {
        if ($scope.CIFInvestor.KeyQuestion10) {
            if ($scope.CIFInvestor.KeyQuestion10 != "")
                $scope.countKeyQuestion = $scope.countKeyQuestion + 1;

            if ($scope.countKeyQuestion >= 5)
                $scope.keyQuestionRequired = false;
        }

        console.log('countKeyQuestion10', $scope.countKeyQuestion);
    };

    $scope.logOff = function () {
        $http({
            method: 'POST',
            url: '/service/client.svc/logOff',
        }).then(function (data) {
            console.log(data);
            if (data.data.d == true) {
                $window.location.href = "#/login";
                $window.location.reload();
            }
        }, function (error) { })
    };


});


